const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 16,
    color: "#FFFFFF",
    boxShadow: "none"
  }),
  cometPaper: theme.mixins.gutters({
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: -18,
    color: "#FFFFFF",
    boxShadow: "none"
  }),
  result: {
    flexGrow: 1
  },
  flex: {
    flexGrow: 1
  },
  buttons: {
    textAlign: "right"
  },
  link: {
    marginLeft: 10,
    marginRight: 10
  },
  testPass: {
    backgroundColor: "#4caf50"
  },
  testFail: {
    backgroundColor: "#ff5252"
  },
  resultNav: {
    flex: "0 0 76px!important",
    maxWidth: "76px!important",
    padding: "4px!important",
    height: "40px"
  },
  resultButtons: {
    padding: "0!important",
    height: "40px",
    textAlign: "center"
  },
  nav: {
    textAlign: "left",
    whiteSpace: "nowrap",
    "& a": {
      width: "28px",
      height: "28px",
      minHeight: "unset"
    }
  },
  status: {
    textAlign: "center",
    //paddingTop: "9px",
    fontSize: "1rem !important",
    color: "white",
    whiteSpace: "nowrap"
  },
  resultsViewer: {
    flex: 2
  },
  table: {
    padding: "4px 0px 4px 0px"
  },
  success: {
    backgroundColor: "#43A547",
    color: "#fff"
  },
  fail: {
    backgroundColor: "#ff5252",
    color: "#fff"
  },
  unknown: {
    backgroundColor: "#72757A",
    color: "#fff"
  },
  text: {
    paddingTop: "9px",
    fontSize: "1rem",
    fontWeight: "500",
    width: "100%",
    paddingRight: "0",
    color: "white",
    letterSpacing: "0.5px"
  },
  headerText: {
    paddingTop: "0px",
    fontSize: "1rem",
    fontWeight: "500",
    width: "100%",
    paddingRight: "0",
    color: "white",
    letterSpacing: "0.5px"
  },
  resultNameBar: {
    flex: "1 1 auto!important",
    maxWidth: "none!important",
    minWidth: 0,
    paddingLeft: "8px!important",
    textAlign: "left"
  },
  resultNameText: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left!important"
  },
  resultStatusBar: {
    flex: "0 0 200px!important",
    maxWidth: "200px!important"
  },
  resultCountBar: {
    flex: "0 0 156px!important",
    maxWidth: "156px!important"
  },
  resultCountText: {
    whiteSpace: "nowrap"
  },
  signaltekHeaderText: {
    lineHeight: "40px!important",
    margin: "0!important",
    paddingTop: "0!important"
  },
  resultDropdownBar: {
    flex: "0 0 148px!important",
    maxWidth: "148px!important"
  },
  signaltekDropdownBar: {
    alignItems: "center",
    display: "flex"
  },
  signaltekResultsDD: {
    "& > div": {
      alignItems: "center",
      display: "flex",
      height: "40px",
      paddingBottom: "0!important",
      paddingTop: "0!important"
    }
  },
  resultDropdownHidden: {
    display: "none"
  },
  resultActions: {
    flex: "0 0 72px!important",
    maxWidth: "72px!important",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0!important",
    height: "40px"
  },
  compactActionButton: {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    padding: 0
  },
  chartSettings: {
    color: "#FFFFFF"
  },
  smartFlagButton: {
    minWidth: "initial",
    width: "28px",
    height: "28px",
    padding: 0,
    marginLeft: theme.spacing.unit,
    verticalAlign: "middle"
  },
  smartFlagFailIcon: {
    color: theme.palette.fail
  },
  smartFlagPassIcon: {
    color: theme.palette.success
  },
  menuItem: {
    height: "auto",
    color: "red"
  },
  radiogroup: {
    textTransform: "uppercase",
    fontSize: "11px",
    color: "#A2AABD"
  },
  cardActionsNav: {
    color: "white"
  },
  resultBar: {
    lineHeight: "40px",
    paddingTop: "0!important",
    paddingBottom: "0!important",
    textAlign: "center",
    borderRight: "1px solid #D6D6D6",
    fontSize: "0.8rem",
    height: 40,
    "& h3": {
      lineHeight: "40px",
      textAlign: "center",
      fontSize: "0.8rem"
    },
    "& span": {
      fontSize: "0.8rem"
    }
  },
  resultBarDropDown: {
    width: "100%",
    padding: "0 8px",
    height: "40px",
    "& div": {
      width: "100%"
    }
  },
  selectItem: {
    fontSize: "0.9rem",
    fontWeight: "500",
    color: "white",
    paddingBottom: "1%"
  },
  resultsDD: {
    "& > div": {
      fontSize: "1rem",
      fontWeight: "500",
      width: "100%",
      paddingRight: "0",
      color: "white",
      letterSpacing: "0.5px"
    }
  },
  settingsMenu: {
    color: "red"
  },
  attachmentExists: {
    backgroundColor: "#FF7043",
    //'& span:first-child':{
    //},
    "&:hover": {
      backgroundColor: "#FF7043"
    }
  }
});

export default styles;
